import { render, staticRenderFns } from "./case-dashboard.vue?vue&type=template&id=d1921010&scoped=true"
import script from "./case-dashboard.vue?vue&type=script&lang=js"
export * from "./case-dashboard.vue?vue&type=script&lang=js"
import style0 from "./case-dashboard.vue?vue&type=style&index=0&id=d1921010&prod&lang=scss"
import style1 from "./case-dashboard.vue?vue&type=style&index=1&id=d1921010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1921010",
  null
  
)

export default component.exports